module.exports = __webpack_public_path__ + "static/media/Offset-printing Icon.908709b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Offset-printing Icon.png
// module id = 1799
// module chunks = 0